import type { UserAchievement } from "../../types";

export const ACHIEVEMENTS_GRID_MAX_ITEMS = 6;

export type CardGoalsProps = {
  achievements: UserAchievement[]
}
